const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const VISITOR_KEY = 'estadia_qr_vid';
const VIEWED_KEY = 'estadia_qr_viewed';

function visitorId() {
  try {
    let id = localStorage.getItem(VISITOR_KEY);
    if (!id) {
      id = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`).slice(0, 64);
      localStorage.setItem(VISITOR_KEY, id);
    }
    return id;
  } catch { return ''; }
}

export function trackQrEvent(event, linkId) {
  const payload = JSON.stringify({ event, link_id: linkId || null, visitor_id: visitorId(), referrer: document.referrer || '' });
  try {
    fetch(`${BACKEND_URL}/api/qr/track`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: payload, keepalive: true,
    }).catch(() => {});
  } catch { /* analytics must never break the page */ }
}

export function trackQrViewOnce() {
  try {
    if (sessionStorage.getItem(VIEWED_KEY)) return;
    sessionStorage.setItem(VIEWED_KEY, '1');
  } catch { /* fall through and count the view */ }
  trackQrEvent('view');
}
